const ROOT = `${process.env.REACT_APP_URL_API_V2}properties/`
// const ROOT = 'properties/'

export default {
	arrayList: `${ROOT}list`
}
